module.exports = __webpack_public_path__ + "img/absolutelyEmpty.3e1572ef.png";